<template>
  <div :class="tooltipClass" :style="position">
    <p class="dawn-input-tooltip-header">{{ helptipHeaderMsg }}</p>
    <p class="small">{{ helptipBody }}
      <slot name="message"></slot>
    </p>
    <div class="info-text">
      <slot name="info"></slot>
    </div>
  </div>
</template>

<script>

  let interactionHandler = null

  const defaultClass = 'dawn-input-tooltip'
  const errorClass = 'error-message'

  const NAVBAR_HEIGHT = 160

  const DEFAULT_TITLE = 'What is this?'
  const DEFAULT_MESSAGE = 'Please fill in this field'
  const ERROR_MESSAGE = 'Invalid Entry'

  export default {
    name: 'ed-input-tooltip',

    props: {
      helptipHeader: {
        type: String,
        default: DEFAULT_TITLE
      },
      helptipBody: {
        type: String,
        default: DEFAULT_MESSAGE
      },
      errorTip: {
        type: Boolean,
        default: false
      },
      altTip: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      helptipHeaderMsg() {
        return this.errorTip && this.helptipHeader === DEFAULT_TITLE
          ? ERROR_MESSAGE
          : this.helptipHeader
      },
      tooltipClass() {
        return `${defaultClass} ${this.$slots.default ? 'info' : this.altTip ? 'alt-message' : ''}`
      }
    },

    data() {
      return {
        position: {}
      }
    },

    created() {
      this.setContext()

      if (!interactionHandler) {
        setTimeout(() => document.addEventListener('click', this.interactionHandler), 0)
        interactionHandler = true
      }

      this.$parent.$on('hook:destroyed', () => {
        document.removeEventListener('click', this.interactionHandler)
        interactionHandler = null
      })

      this.unwatchError = this.$parent.$watch('error', this.errorHandler)
      this.unwatchFocused = this.$parent.$watch('focused', this.visibilityHandler)
      this.unwatchIsOpen = this.$parent.$watch('isOpen', this.visibilityHandler)
      this.unwatchShowPopup = this.$parent.$watch('showPopup', this.visibilityHandler)
    },

    mounted() {
      this.scrollToError()

      //
      if (typeof this.$attrs['v-align'] !== 'undefined') {
        this.position = {
          top: `${-this.$el.clientHeight / 2 + 45}px`
        }
      }
    },

    destroyed() {
      // document.removeEventListener('click', this.interactionHandler)
      setTimeout(() => {
        this.unwatchError()
        this.unwatchFocused()
        this.unwatchIsOpen()
        this.unwatchShowPopup()
      }, 500)
    },

    methods: {
      setContext() {
        this.context = document.querySelector('.dawn-modal-container') || document
        this.viewport = document.querySelector('.dawn-modal-container')
          ? document.querySelector('.dawn-modal-mask')
          : document.querySelector('.main-panel')
      },

      interactionHandler(e) {
        if (e.target.type === 'button') {
          this.scrollToError()
        }
      },

      errorHandler(oldV, newV) {
        if (newV) {
          setTimeout(() => document.addEventListener('click', this.interactionHandler), 0)
          this.scrollToError()
        }
      },

      scrollToError(error) {
        if (this.errorTip || this.shouldScrollToNextError) {
          this.$nextTick(() => {
            this.scrollFirstIntoView()
            this.hideOtherErrors()
          })
        } else {
          if (!error) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.shouldScrollToNextError = true
                this.unwatchError()
              }, 100)
            })
          } else {
            this.shouldScrollToNextError = false
          }
        }
      },

      visibilityHandler(v) {
        v
          ? this.$el.classList.remove('invisible')
          : this.$el.classList.add('invisible')
      },

      scrollFirstIntoView() {
        const firstError = this.context.querySelectorAll(`.${defaultClass}.${errorClass}`)[0]
        if (firstError) {
          firstError.scrollIntoView()
          firstError.classList.remove('invisible')
          this.viewport.scrollTop += firstError.getBoundingClientRect().top - NAVBAR_HEIGHT

          //
          if (window !== window.parent) {
            setTimeout(() => {
              window.parent.scrollTo(0, 0)
            }, 0)
          }
        }
      },

      hideOtherErrors() {
        this.context.querySelectorAll(`.${defaultClass}.${errorClass}`).forEach((error, i) => {
          if (i === 0) {
            //
          } else {
            error.getAttribute('upload-message') || error.classList.add('invisible')
          }
        })
      }
    }
  }
</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/font-awesome/_variables.scss";

.dawn-input-tooltip {
  z-index: 9999;
  position: absolute;
  left: 105%;
  top: 25%;
  width: 100%;
  max-width: 400px;

  &.error.error-message {
    min-height: 40px;
    margin-top: 3px;
    padding: 0.7em;
    line-height: 1.3;
    p {
      margin: 0;
      font-size: $font-size-base-sm;
    }

    &:after {
      border-width: 10px;
      margin-top: -10px;
    }
    &:before {
      border-width: 11px;
      margin-top: -11px;
    }
  }

  &.alt-message {
    max-width: 260px;
    .dawn-input-tooltip-header, p.small {
      padding-left: 20px;
    }
  }

  .validation-list {
    list-style: none;
    padding: 0.5em 0;
    li {
      @include fa-icon-only($fa-var-circle, 'Regular');
      &:before {
        margin-left: -20px;
        margin-right: 10px;
      }
      opacity: 0.5;
      &.valid {
        @include fa-icon-only($fa-var-check-circle, 'Regular');
        &, &:before {
          @include theme {
          color: v(tertiary-01);
          }
        }
        opacity: 1;
      }
      &.invalid {
        @include fa-icon-only($fa-var-times-circle, 'Regular');
        &, &:before {
          @include theme {
          color: v(urgent-01);
          }
        }
        opacity: 1;
      }
    }
  }

  &:not(.info) {
    padding: 1em;
    background: linear-gradient(#fefefe, #f8f8f8);
    border: $border-width-default solid;
    @include theme {
    border-color: v(background);
    }
    border-radius: $border-radius;
    box-shadow: 0px 3px 4px 2px rgba(0, 0, 0, 0.06);
    top: 18%;
  }

  &.error-message.error-message {
    @include theme {
    border-color: v(urgent-01);
    }

    &:before {
      border-color: rgba(194, 225, 245, 0);
      @include theme {
      border-right-color: v(urgent-01);
      }
    }
  }
}

.form-group.small.inline .dawn-input-tooltip {
  top: -22px;
  left: 110%;
}
.dawn-input-tooltip.info {
  &:after, &:before {
    display: none;
  }
}
.dawn-input-tooltip:not(.info):after, .dawn-input-tooltip:not(.info):before {
  right: 100%;
  top: 50%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.dawn-input-tooltip:not(.info):after {
  border-color: rgba(136, 183, 213, 0);
  border-right-color: #fbfbfb;
  border-width: 14px;
  margin-top: -14px;
}
.dawn-input-tooltip:not(.info):before {
  border-color: rgba(194, 225, 245, 0);
  @include theme {
  border-right-color: v(background);
  }
  border-width: 15px;
  margin-top: -15px;
}

.dawn-input-tooltip-header {
  font-weight: $font-weight-ultra-bold;
  margin-bottom: 0;
  font-size: $font-size-base;
}

.dawn-input-tooltip-body {
  margin-bottom: 0;
  font-size: $font-size-medium;
}

.info-text {
  font-size: $font-size-base;
  font-weight: $font-weight-bold;
  line-height: 1.2em;

  .text-warning {
    @include theme {
    color: v(attention-01);
    }
  }

  .text-danger {
    @include theme {
    color: v(urgent-01);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/core/components/edInputTooltip/index.vue